var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDesktop = function SvgDesktop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66641 2.06738C3.23047 2.06738 2.06641 3.23144 2.06641 4.66738V10.0674H2.00104C1.30148 10.0674 0.734375 10.6345 0.734375 11.3341C0.734375 12.77 1.89843 13.934 3.33437 13.934H12.6677C14.1036 13.934 15.2677 12.77 15.2677 11.3341C15.2677 10.6345 14.7006 10.0674 14.001 10.0674H13.9331V4.66738C13.9331 3.23144 12.769 2.06738 11.3331 2.06738H4.66641ZM12.7331 10.0674V4.66738C12.7331 3.89418 12.1063 3.26738 11.3331 3.26738H4.66641C3.89321 3.26738 3.26641 3.89418 3.26641 4.66738V10.0674H12.7331ZM2.00104 11.2674C1.96422 11.2674 1.93438 11.2972 1.93438 11.3341C1.93438 12.1072 2.56118 12.734 3.33437 12.734H12.6677C13.4409 12.734 14.0677 12.1072 14.0677 11.3341C14.0677 11.2972 14.0379 11.2674 14.001 11.2674H2.00104Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "desktop.9dad224494d2330b21b87b884e22f58f.svg";